import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-cambio-clave',
  templateUrl: './cambio-clave.component.html',
  styleUrls: ['./cambio-clave.component.css']
})
export class CambioClaveComponent implements OnInit {
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private messageDialog: string = '';
  private resultDialog: string = '';

  constructor(
    private helperClassService: HelperClassService,
    public apiCallService: ApiCallService,
    private router: Router) { }

  ngOnInit() {
  }

  resetearClaveForm = new FormGroup({
    claveActual: new FormControl('', [Validators.required, Validators.pattern(Constanst.REGEXP_PASSWORD)]),
    nuevaClave: new FormControl('', [Validators.required, Validators.pattern(Constanst.REGEXP_PASSWORD)]),
  });

  onSubmit(): void {
    if (this.resetearClaveForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_PASSWORD, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/changePassword';
        this.method = 'POST';

        let data = {
          newPassword: this.resetearClaveForm.controls['nuevaClave'].value,
        }
        //console.log(data);
        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(
            response => {
              //console.log(response);
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.messageDialog = Constanst.MSG_PASSWORD_CHANGED;
                this.resultDialog = Constanst.DIALOG_RESULT_SUCCESS;
              } else {
                this.messageDialog = Constanst.MSG_GENERIC_ERROR;
                this.resultDialog = Constanst.DIALOG_RESULT_ERROR;
              }

              this.apiCallService.hideSpinner();
              const dialog = this.helperClassService.openDialogGeneric('25rem', true, this.messageDialog, false, true, false, '', '', '', this.resultDialog);
              dialog.afterClosed().subscribe(() => {
                if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                  this.router.navigate(['menu']);
                }
              });

            },
            error => {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              this.router.navigate(['menu']);
            }
          );

      } else {
        dialog.close(false);
      }
    });
  }

  navigateMenu() {
    let viewScreen = (localStorage.getItem(Constanst.STORAGE_DATA_SCREENTYPE) != null ? localStorage.getItem(Constanst.STORAGE_DATA_SCREENTYPE) : Constanst.SCREEN_TYPE_BD);
    if (viewScreen == '1') {
      this.router.navigate(['/' + 'home']);
    } else {
      this.router.navigate(['/' + 'presupuestos']);
    }
  }

}
